import { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router';
import { scrollToTop } from '../../../utils';
import {
    useButtonsStore,
    useAPIKeyStore,
} from '../../../store/models';
import useEcalWorldAsDev from '../../ecalworld/useEcalWorldAsDev';

import useStoreModuleDependency from '../../hooks/useStoreModuleDependency';

function getVisibleColumns (columns, devAccess) {
    if (devAccess) {
        return columns;
    }
    return columns.filter((column) => column.id !== 'ecalWorld');
}

function useModuleList (props) {
    const {
        columns,
    } = props;
    const history = useHistory();
    const { devAccess } = useEcalWorldAsDev();
    // visibleColumns is purely derived from columns/devAccess, so it's computed during render
    // rather than via a useState+useEffect pair — that pattern renders once with the stale
    // value, then a second time once the effect catches up, whenever devAccess resolves
    // asynchronously (after the Cognito/role-hydration chain finishes, well after mount).
    const visibleColumns = useMemo(
        () => getVisibleColumns(columns, devAccess),
        [columns, devAccess],
    );

    const apikeyStore = useAPIKeyStore();
    const buttonsStore = useButtonsStore();
    const [listData, setListData] = useState([]);
    const [progress, setProgress] = useState({
        buttons: false,
    });

    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(false);
    const [pageInfo, setPageInfo] = useState(buttonsStore.pageInfo);
    const [selectedRows, setSelectedRows] = useState([]);
    const [activeAPIKey, setActiveAPIKey] = useState('');

    useEffect(() => {
        if (buttonsStore.buttons) {
            setListData(buttonsStore.buttons);
            setPageInfo({
                ...pageInfo,
                ...buttonsStore.pageInfo,
            });
        }
        setProgress({ ...progress, buttons: false });
    }, [buttonsStore.observed.buttons]);

    useEffect(() => {
        if (apikeyStore.apikeys && apikeyStore.apikeys.length > 0) {
            setActiveAPIKey(apikeyStore.apikeys[0].id);
        }
    }, [apikeyStore.observed.apikeys]);

    function initStore () {
        setProgress({ ...progress, buttons: true });
        const type = 'button';
        apikeyStore.getAPIKeys();
        buttonsStore.getButtons(type);
        buttonsStore.getPublisherButton();
        scrollToTop();
    }

    useStoreModuleDependency({ initStore });

    function deleteSingle (row) {
      setProgress({
          ...progress,
          buttons: true,
      });
      buttonsStore.deleteWidgets([row.id]);
  }

    function saveEditData (data) {
        console.log('button.useModuleList().saveEditData()', data);
        buttonsStore.saveEditData(data);
        history.push('/admin/displays/button/edit/' + data.id);
    }

    function updatePageInfo (info) {
        buttonsStore.pageInfo = {
            ...pageInfo,
            ...info,
        };
        setPageInfo({
            ...buttonsStore.pageInfo,
        });
        setProgress({
            ...progress,
            buttons: true,
        });
        const type = 'button';
        buttonsStore.getButtons(type);
    }

    function makeDraft () {
        setProgress({
            ...progress,
            buttons: true,
        });
         buttonsStore.makeWidgetsDraft(selectedRows);
    }

    function makeLive () {
        setProgress({
            ...progress,
            buttons: true,
        });
        buttonsStore.makeWidgetsLive(selectedRows);
    }

    function deleteSelection () {
        setProgress({
            ...progress,
            buttons: true,
        });
        console.log('deleteSelection():', selectedRows);
        buttonsStore.deleteWidgets(selectedRows);
    }

    return {
        listData,
        progress,
        saveEditData,

        deleteOpen,
        deleteTarget,
        setDeleteOpen,
        setDeleteTarget,
        pageInfo,
        updatePageInfo,

        selectedRows,
        setSelectedRows,

        visibleColumns,
        makeDraft,
        makeLive,
        deleteSingle,
        deleteSelection,
        activeAPIKey,
    };
}

export default useModuleList;
